export default {"tab-icon":"icon-tab-module__tab-icon___nmgKn","highlighted":"icon-tab-module__highlighted___a09N-"}
import '/home/jenkins/agent/workspace/_release_release_t3-widgets_15.1/packages/common/widgets/src/components/tab-bar/icon-tab.module.css'
